import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=8acda782&scoped=true&lang=pug&"
import script from "./menuItem.vue?vue&type=script&lang=js&"
export * from "./menuItem.vue?vue&type=script&lang=js&"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=8acda782&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acda782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8acda782', component.options)
    } else {
      api.reload('8acda782', component.options)
    }
    module.hot.accept("./menuItem.vue?vue&type=template&id=8acda782&scoped=true&lang=pug&", function () {
      api.rerender('8acda782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/others/contextmenu/menuItem.vue"
export default component.exports